/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Err_Otp_MsgInputs */

const es_ab_err_otp_msg = /** @type {(inputs: Ab_Err_Otp_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El código introducido no es válido o ha caducado. `)
};

const gl_ab_err_otp_msg = /** @type {(inputs: Ab_Err_Otp_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O código introducido non é válido ou caducou. `)
};

const en_ab_err_otp_msg = /** @type {(inputs: Ab_Err_Otp_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The code is invalid or has expired. `)
};

/**
* | output |
* | --- |
* | "The code is invalid or has expired." |
*
* @param {Ab_Err_Otp_MsgInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_err_otp_msg = /** @type {((inputs?: Ab_Err_Otp_MsgInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Err_Otp_MsgInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_err_otp_msg(inputs)
	if (locale === "en") return en_ab_err_otp_msg(inputs)
	return es_ab_err_otp_msg(inputs)
});